export default __webpack_public_path__ + "static/cat-1-moc-1-540cd866a0bc4aeefb6e19983ef2735d.png";